<template>

  <div class="user">
    <!--添加任务 @tab-click="handleClick"-->
     <el-tabs v-model="activeName" >
          <el-tab-pane label="摄像头列表" name="list"></el-tab-pane>
          <el-tab-pane label="摄像头设置" name="setting"></el-tab-pane>
      </el-tabs>


        <div class="user" v-if="'setting' == activeName">
        <el-form size="small" ref="formsetting" :model="formsetting" label-width="150px">
          <el-form-item label="是否开启" prop="is_coupon">
            <el-switch v-model="formsetting.status"></el-switch>
          </el-form-item>

          <el-form-item label="AppKey" prop="AppKey">
            <el-input v-model="formsetting.AppKey"></el-input>
          </el-form-item>

          <el-form-item label="Secret" prop="Secret">
            <el-input v-model="formsetting.Secret"></el-input>
          </el-form-item>

                 <el-form-item label="测试地址" prop="url1">
          <el-input type="textarea" v-model="formsetting.url1"></el-input>
      </el-form-item>



      <!-- <el-form-item label="AccessToken" prop="AccessToken">
            <el-input v-model="formsetting.AccessToken"></el-input>
          </el-form-item> -->


    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmitx" :disabled="loading">保存</el-button>
    </div>

  </div>
    
    
    <div class="common-seach-wrap" v-if="'list' == activeName">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="摄像头名称">
          <el-input placeholder="请输入摄像头名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
             <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail"  v-if="'list' == activeName">
     
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加摄像头</el-button>
    </div>

    <div class="product-content"  v-if="'list' == activeName">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="摄像头名称"></el-table-column>
  <el-table-column prop="type" label="摄像头类型">
    <template #default="scope">
      {{ scope.row.type === '1' ? '平台' : '工厂' }}
    </template>
  </el-table-column>
<el-table-column
  prop="status"
  label="摄像头状态"
  :formatter="formatStatus">
</el-table-column>

  
            <el-table-column prop="identify_code" label="摄像头识别码"></el-table-column>
    <el-table-column prop="sn" label="摄像头SN码"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" :supply_id="supply_id"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :camera_id="camera_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import CameraApi from '@/api/camera.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {

          formsetting:{
              status: false,
              AppKey:"",
              Secret:"",
              AccessToken:"",

          },


        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        camera_id:"",
        dialogVisible:false,
        supply_id:0,
        activeName:"list"
      };
    },
    created() {
         this.supply_id =  this.$route.query.supply_id;
      this.formInline.supply_id = this.$route.query.supply_id;
      /*获取列表*/
      this.getTableList();
      this.getSetting();
    },
    methods: {

        /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      CameraApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.formsetting = data.data.vars.values;
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmitx() {
      let self = this;
      let params = self.formsetting;
      self.loading = true;
      CameraApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },







        formatStatus(row) {
    const statusMap = {
      '0': '关闭',
      '1': '开启', 
      '2': '未知'
    };
    return statusMap[row.status] || '未知';
  },
           /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//摄像头标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Params.supply_id = self.supply_id;
        CameraApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

        settingClick(row) {
  
        this.$router.push({
          path: '/plus/camera/setting/getSetting',

        });
    },
      /*编辑活动*/
      editClick(row) {
        this.camera_id = row.camera_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CameraApi.del(
              {
                camera_id: row.camera_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/camera/index/index.vue